var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 58,
    viewBox: "0 0 50 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 58C23.9017 58 22.8602 57.7337 22.0578 57.2543L2.94218 45.7786C1.29183 44.7902 0 42.4584 0 40.4816V17.5243C0 15.5416 1.29183 13.2157 2.94218 12.2273L22.0578 0.745714C22.8602 0.266326 23.9074 0 25 0C26.0983 0 27.1398 0.266326 27.9422 0.745714L47.0578 12.2214C48.7082 13.2098 50 15.5416 50 17.5184V40.4757C50 42.4584 48.7082 44.7843 47.0578 45.7726L27.9422 57.2543C27.1398 57.7337 26.0983 58 25 58Z",
    fill: "#FCC800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1728 10.5469C30.8746 10.5469 35.5039 15.1616 35.5039 20.8563C35.5039 26.551 30.8746 31.1657 25.1728 31.1657C19.4661 31.1657 14.8417 26.551 14.8417 20.8563C14.8417 15.1616 19.4661 10.5469 25.1728 10.5469ZM25.1728 46.6298C16.3963 46.6298 12.5 43.0215 12.5 42.3048C12.5 38.8585 13.8086 35.6184 15.9831 33.1981C18.4232 35.2797 21.6258 36.5855 25.1728 36.5855C28.7346 36.5855 31.9471 35.2747 34.397 33.1785C36.5518 35.6086 37.8456 38.8585 37.8456 42.3048C37.8456 43.0215 33.9493 46.6298 25.1728 46.6298Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHead);
export default __webpack_public_path__ + "static/media/icon_head.cf81770f85b21dfa7347f3d21e40493f.svg";
export { ForwardRef as ReactComponent };